import React from 'react';
import { API_URLS } from '../api/API_URLS';

import { addLocation } from '../../data/serviceClients';

import { ActionTabs } from './ActionTabs';
import { InputRow } from './InputRow';

import { showMessage, hideMessage } from '../uiFunctions/uiActions';

class Location extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            locations: this.props.locations,
        }
        this.update = this.update.bind(this);
        this.updateHoliday = this.updateHoliday.bind(this);
        this.updateCrm = this.updateCrm.bind(this);
    }

    add(type) {
        showMessage("Adding New Location...");
        var body = {
            "clientCode": this.props.clientCode,
            "type": type,
            "name": "New Location"
        }
        addLocation(body).then(data => {
            hideMessage(data.success);
            if (data.success) {
                var newState = this.state.locations;
                newState.push(data.result);
                this.setState({ locations: newState });
            }
        })
        .catch(error => console.log(error));
    }
    addHoliday(id) {
		const locationIndex = this.state.locations.findIndex(store => store.id === id )
        let newState = this.state.locations;
        newState[locationIndex].holidays.push({"date":null,"hours":null,"comment":null},);

        this.setState({locations: newState});
	}
    addCrm(id) {
		const locationIndex = this.state.locations.findIndex(store => store.id === id )
        let newState = this.state.locations;
        newState[locationIndex].crmData.push({"platform":null,"crmId":null,"crmName":null},);

        this.setState({locations: newState});
	}
    deleteCrm(id, index) {
		const locationIndex = this.state.locations.findIndex(store => store.id === id )
        let newState = this.state.locations;
        newState[locationIndex].crmData.splice(index, 1);

        this.setState({locations: newState});
	}

    update(e) {
		var id = e.target.attributes.customdata.value;
		id = parseInt(id, 10);
        var locIndex = this.state.locations.findIndex(loc => loc.id === id );
		var key = e.target.name;
		var value = e.target.value;
        if (e.target.type === "checkbox") {
			value = e.target.checked;
		}

        console.log(key, value);

        this.setState(state => {
            state.locations[locIndex][key] = value
            return state
        });
	}
    updateHoliday(e) {
        var holidayIndex = e.target.attributes.customdata.value;
		holidayIndex = parseInt(holidayIndex, 10);
        let id = document.querySelectorAll("div#"+this.props.container+"-inputs .tab.active input[name='id']")[0].value;
        id = parseInt(id, 10);
        let locIndex = this.state.locations.findIndex(loc => loc.id === id );
		var key = e.target.name;
		var value = e.target.value;

        this.setState(state => {
            state.locations[locIndex].holidays[holidayIndex][key] = value
            return state
        });
    }
    updateCrm(e) {
        var crmIndex = e.target.attributes.customdata.value;
		crmIndex = parseInt(crmIndex, 10);
        let id = document.querySelectorAll("div#"+this.props.container+"-inputs .tab.active input[name='id']")[0].value;
        id = parseInt(id, 10);
        let locIndex = this.state.locations.findIndex(loc => loc.id === id );
		var key = e.target.name;
		var value = e.target.value;

        this.setState(state => {
            state.locations[locIndex].crmData[crmIndex][key] = value
            return state
        });
    }

    updateLocation(action) {
        // need to fix this.. make it work just like contacts file
        if (action === "delete") {
            var strconfirm = window.confirm("Are you sure you want to delete?");
            if (strconfirm !== true) {
                showMessage("Deleting Location...");
                return;
            }
        }
        showMessage("Saving Location...");

        let id = document.querySelectorAll("div#"+this.props.container+"-inputs .tab.active input[name='id']")[0].value;
        id = parseInt(id, 10);
        let keyIndex = this.state.locations.findIndex(loc => loc.id === id );

        let fetchUrl = API_URLS.postLocation;
        var postAction = "POST";
        if (action === "delete") {
            postAction = "DELETE";
            fetchUrl += "/"+id;
        }
        let paramsBody = this.state.locations[keyIndex];

        console.log(paramsBody)

        var params = {
            headers: {
                "authorization": "Bearer " + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(paramsBody),
            method: postAction,
        }

            fetch(fetchUrl, params)
                .then(response => {
                    if (response.ok) {
                        // console.log(response);
                        return response.json();
                    } else { throw new Error('Something went wrong ...'); }
                })
                .then(data => {
                    // console.log(data);

                    if (postAction === "POST" && keyIndex >= 0) {
                        let arr = [
                            ...this.state.locations.slice(0, keyIndex),
                            {...data.result },
                            ...this.state.locations.slice(keyIndex + 1),
                        ];
                        this.setState({ locations: [...arr] });
                    }
                    hideMessage(data.success)
                })
                .catch(error => console.log(error));
        }

    render() {
        const { locations } = this.state;
        const type = this.props.type;
        const container = this.props.container;

        return(
            <div>
                <ActionTabs
                    handleAdd={() => this.add(type)}
                    handleSave={() => this.updateLocation("save")}
                    handleDelete={() => this.updateLocation("delete")}
                    tabs={locations}
                    id={container}
                />
                <div id={container+"-inputs"} className="inputs">
                    {(locations.map(location =>
                        (<React.Fragment key={location.id}>
                            <div id={container+"-"+location.id} className={"tab "+container+"-"+location.id}>

                                <input type="hidden" name="clientCode" value={location.clientCode} hidden="hidden" />
                                <input type="hidden" name="type" value={location.type} hidden="hidden" />

                                <InputRow onChange={this.update} data={location.id} label={(type === "billing") ? ("Business Name") : ("Name")} type="text" value={location.name} property="name" />
                                <InputRow data={location.id} label="ID" type="text" value={location.id} property="id" disabled />
                                {(type === "store") && (
                                    <React.Fragment>
                                        <InputRow onChange={this.update} data={location.id} label="Primary Location? (used for leads)" type="checkbox" value={location.primary} property="primary" />
                                        <InputRow onChange={this.update} data={location.id} label="Location Code" type="text" value={location.locationCode} property="locationCode" />
                                        <InputRow onChange={this.update} data={location.id} label="Facebook Store ID" type="text" value={location.facebookStoreId} property="facebookStoreId" />
                                    </React.Fragment>
                                )}
                                <h4>Address Info</h4>
                                <InputRow onChange={this.update} data={location.id} label="Address" type="text" value={location.address} property="address" />
                                <InputRow onChange={this.update} data={location.id} label="City" type="text" value={location.city} property="city" />
                                <InputRow onChange={this.update} data={location.id} label="State" type="text" value={location.state} property="state" />
                                <InputRow onChange={this.update} data={location.id} label="Postal Code" type="text" value={location.postalCode} property="postalCode" />
                                {(type === "store") && (
                                    <React.Fragment>
                                        <InputRow
                                            label="Country"
                                            type="select"
                                            value={location.country}
                                            property="country"
                                            id="country"
                                            hideSelectOption="true"
                                            options={[
                                                { "name": "USA", "value": "US"},
                                                { "name": "Canada", "value": "CA"}
                                            ]}
                                            onChange={this.update} data={location.id}
                                        />
                                        <InputRow onChange={this.update} data={location.id} label="Latitude" type="text" value={location.lat} property="lat" />
                                        <InputRow onChange={this.update} data={location.id} label="Longitude" type="text" value={location.lng} property="lng" />
                                    </React.Fragment>
                                )}

                                <h4>Contact/Store Info</h4>
                                <InputRow onChange={this.update} data={location.id} label="Fax" type="text" value={location.fax} property="fax" />
                                <InputRow onChange={this.update} data={location.id} label="Email" type="text" value={location.email} property="email" />
                                <InputRow onChange={this.update} data={location.id} label="Phone" type="text" value={location.phone} property="phone" />
                                {(type === "store") && (
                                    <React.Fragment>
                                        <InputRow onChange={this.update} data={location.id} label="Call Forwarding/Tracking Number" type="text" value={location.forwardingPhone} property="forwardingPhone" />
                                        <InputRow onChange={this.update} data={location.id} label="Paid Search Forwarding/Tracking Number" type="text" value={location.paidSearchForwardingPhone} property="paidSearchForwardingPhone" />
                                        <InputRow onChange={this.update} data={location.id} label="License Number" type="text" value={location.licenseNumber} property="licenseNumber" />
                                        <InputRow onChange={this.update} data={location.id} label="From Email" type="text" value={location.leadEmail} property="leadEmail" description="From address used by the SendGrid to send Promo or Email Campaign events to the Customer." />
                                        <InputRow onChange={this.update} data={location.id} label="URL" type="text" value={location.url} property="url" description="if custom / location specific URL is not supplied here, the website URL in the Website Information section will be used." />
                                    </React.Fragment>
                                )}

{/* ---------------STORE ONLY---------------- */}

                                {(type === "store") && (
                                    <React.Fragment>
                                        <h4>CRM Connections</h4>
                                        <div className="tabs-wrapper">
                                            <ActionTabs
                                                handleAdd={() => this.addCrm(location.id)}
                                                handleSave={() => this.updateLocation("save")}
                                            />
                                        </div>
                                        {(location.crmData) && (
                                            location.crmData.map((crm, index) =>
                                                <div className="" key={index} >
                                                    <div className="delete"><i className="far fa-trash-alt icon" onClick={() => this.deleteCrm(location.id, index)}></i></div>
                                                    <InputRow
                                                        label="Platform"
                                                        type="select"
                                                        value={crm.platform}
                                                        property="platform"
                                                        id="platform"
                                                        hideSelectOption="false"
                                                        options={[ //list of CRMs from credentials.. maybe move to helpers eventually
                                                            { "name": "CRM - Builder Prime", "value": "builderPrime"},
                                                            { "name": "CRM - Hubspot", "value": "hubspot"},
                                                            { "name": "CRM - Pacific Solutions", "value": "pacsol"},
                                                            { "name": "CRM - QFloors", "value": "qfloors"},
                                                            { "name": "CRM - RFMS", "value": "rfms"},
                                                            { "name": "CRM - RLM", "value": "rlm"},
                                                            { "name": "CRM - Rollmaster", "value": "rollmaster"},
                                                            { "name": "CRM - Sharp Spring", "value": "sharpSpring"},
                                                            { "name": "CRM - vTiger", "value": "vtiger"},
                                                            { "name": "CRM - Zendesk", "value": "zendesk"},
                                                            { "name": "CRM - Zendesk Sell", "value": "zendeskSell" }
                                                        ]}
                                                        onChange={this.updateCrm}
                                                        data={index}
                                                    />
                                                    <InputRow onChange={this.updateCrm} data={index} label="ID" type="text" value={crm.crmId} property="crmId" />
                                                    <InputRow onChange={this.updateCrm} data={index} label="Name" type="text" value={crm.crmName} property="crmName" />
                                                </div>
                                            )
                                        )}

                                        <h4>Hours Currently Displayed On Site</h4>
                                        <div>Monday: {location.hours[0].hours}</div>
                                        <div>Tuesday: {location.hours[1].hours}</div>
                                        <div>Wednesday: {location.hours[2].hours}</div>
                                        <div>Thursday: {location.hours[3].hours}</div>
                                        <div>Friday: {location.hours[4].hours}</div>
                                        <div>Saturday: {location.hours[5].hours}</div>
                                        <div>Sunday: {location.hours[6].hours}</div>

                                        <h4>Regular Hours</h4>
                                        <InputRow onChange={this.update} data={location.id} label="Monday" type="text" value={location.monday} property="monday" />
                                        <InputRow onChange={this.update} data={location.id} label="Tuesday" type="text" value={location.tuesday} property="tuesday" />
                                        <InputRow onChange={this.update} data={location.id} label="Wednesday" type="text" value={location.wednesday} property="wednesday" />
                                        <InputRow onChange={this.update} data={location.id} label="Thursday" type="text" value={location.thursday} property="thursday" />
                                        <InputRow onChange={this.update} data={location.id} label="Friday" type="text" value={location.friday} property="friday" />
                                        <InputRow onChange={this.update} data={location.id} label="Saturday" type="text" value={location.saturday} property="saturday" />
                                        <InputRow onChange={this.update} data={location.id} label="Sunday" type="text" value={location.sunday} property="sunday" />

                                        <h4>Alternate Hours / Holidays</h4>
                                        <div className="tabs-wrapper">
                                            <ActionTabs
                                                handleAdd={() => this.addHoliday(location.id)}
                                                handleSave={() => this.updateLocation("save")}
                                            />
                                        </div>
                                        {(location.holidays) && (
                                            location.holidays.map((day, index) =>
                                                <div className="holiday" key={index} >
                                                    <InputRow onChange={this.updateHoliday} data={index} label="Date (required)" type="date" value={day.date} property="date" />
                                                    <InputRow onChange={this.updateHoliday} data={index} label="Hours" type="text" value={day.hours} property="hours" />
                                                    <InputRow onChange={this.updateHoliday} data={index} label="Comment" type="text" value={day.comment} property="comment" />
                                                </div>
                                            )
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        </React.Fragment>)
                    ))}
                </div>
            </div>
        )
    }
}
export default Location;


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/Location.js